<template>
    <p class="my-2">Les villes sont utilisés dans certains formulaires pour definir l'adresse de depart, l'adresse de destination, ou la ville d'un fournisseur, etc</p>
    <button type="button" class="btn btn-sm btn-outline-dark mb-3" @click="openCreateModal()">
        <i class="fas fa-plus"></i> Nouvelle ville
    </button>

    <DataTableBackend :url="'/api/'+table" :columns="columns" :table="table" :perPage="10">
        <template #action_btns=slotProps>
            <button class="btn btn-sm btn-light m-1" @click="openShowModal(slotProps.data)">
                <i class="fa-solid fa-ellipsis"></i>
            </button>
        </template>
    </DataTableBackend>
</template>
    
<script >
import $ from "jquery"
import FormVille from './FormVille.vue'
import ShowVille from './ShowVille.vue'

export default {
    name: 'IndexVille',
    data() {
        return {
            table: 'villes',
            baseUrl: this.$store.state.api_yams_livraisons,
            isLoading: false,
            columns: [
                {
                    key: 'code',
                    label: 'Code',
                    exportable: true
                },
                {
                    key: 'libelle',
                    label: 'Nom',
                    exportable: true
                }
            ]
        }
    },
    methods: {
        openCreateModal() {
            this.$dialog.open(FormVille, {
                props: {
                    header: "Nouvelle ville",
                    style: {
                        width: '20vw'
                    },
                    modal: true
                }
            });
        },
        openShowModal(objData) {
            this.$dialog.open(ShowVille, {
                props: {
                    header: "Ville N°"+objData.id,
                    style: {
                        width: '20vw'
                    },
                    // modal: true
                },
                data: objData
            });
        },
        deleteLine(id) {
            if (!window.confirm("Etes vous sur de vouloir supprimer ?")) {
                return
            }
            this.isLoading = true
            this.axios.post('/api/villes/'+this.table+'/' + id + '/destroy').then(response => {
                this.isLoading = false
                if (response.data.success === true) {
                    $('#refresh' + this.table).click()
                    this.$toast.add({
                        severity: 'success',
                        detail: response.data.message,
                        life: 3000
                    });
                }
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        }
    }
}
</script>
    